export const mascotWithItemsStyles = `
  .qaz-root {
    height: 100%;
    position: relative;
    z-index: 0;
  }
  .qaz-item {
    position: absolute;
    pointer-events: none;
  }
  .qaz-shirt {
    z-index: 10;
    left: 16.5%;
    width: 67%;
    top: 41%;
  }
  .qaz-eye {
    z-index: 10;
    left: 29%;
    width: 41%;
    top: 20%;
  }
  .qaz-glasses {
    z-index: 20;
    left: 22.5%;
    width: 55%;
    top: 14%;
  }
  .qaz-jacket {
    z-index: 30;
    left: 17%;
    width: 65%;
    top: 40%;
  }
  .qaz-head-pompom {
    z-index: 10;
    left: 29%;
    width: 32%;
    top: -7%;
  }
  .qaz-head-plain {
    z-index: 10;
    left: 32%;
    width: 35%;
    top: -3%;
  }
  .qaz-neck-tie {
    z-index: 20;
    left: 35%;
    width: 32%;
    top: 64%;
  }
  .qaz-neck-other {
    z-index: 20;
    left: 25%;
    width: 50%;
    top: 49%;
  }
  .qaz-fill {
    width: 100%;
    height: 100%;
  }
`;
